import React from 'react'
import { Box, Container, Grid, Group, Stack, Text } from '@mantine/core'
import { IconInfoCircle, IconLock, IconSearch, IconShieldCheck } from '@tabler/icons-react'
import { BRAND_COLOR, HERO_CONTENT } from '../utils/constants'

export default function Hero() {
  const highlights = [
    { icon: IconShieldCheck, label: '用户授权', desc: '明确授权后请求' },
    { icon: IconSearch, label: '信息查询', desc: '向第三方请求信息' },
    { icon: IconInfoCircle, label: '结构展示', desc: '整理并展示结果' },
    { icon: IconLock, label: '有限保存', desc: '最长30天后清除' },
  ]

  return (
    <Box
      style={{
        minHeight: '100vh',
        backgroundImage: 'linear-gradient(180deg, #F5F7FA 0%, #FFFFFF 100%)',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '800px',
          height: '800px',
          borderRadius: '50%',
          background: `radial-gradient(circle, ${BRAND_COLOR}08 0%, transparent 70%)`,
          zIndex: 0,
        }}
      />

      <Container size="xl" style={{ position: 'relative', zIndex: 1 }} py={{ base: 60, md: 80 }}>
        <Grid gutter={{ base: 'lg', md: 'xl' }} align="center">
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Stack gap="xl">
              <Box
                style={{
                  display: 'inline-flex',
                  padding: '8px 18px',
                  borderRadius: '999px',
                  backgroundColor: `${BRAND_COLOR}15`,
                  border: `1px solid ${BRAND_COLOR}30`,
                  alignSelf: 'flex-start',
                }}
              >
                <Text size="sm" fw={500} c={BRAND_COLOR}>
                  {HERO_CONTENT.badge}
                </Text>
              </Box>

              <h1
                style={{
                  fontSize: 'clamp(1.75rem, 4vw, 2.5rem)',
                  fontWeight: 700,
                  color: '#1F2329',
                  lineHeight: 1.3,
                  margin: 0,
                }}
              >
                {HERO_CONTENT.title}
              </h1>

              <Text size="lg" c="#1F2329" fw={500} style={{ lineHeight: 1.8 }}>
                {HERO_CONTENT.subtitle}
              </Text>

              <Box
                p="md"
                style={{
                  backgroundColor: '#FEF3C7',
                  border: '1px solid #FCD34D',
                  borderRadius: 12,
                }}
              >
                <Text size="sm" c="#92400E" fw={500}>
                  {HERO_CONTENT.note}
                </Text>
              </Box>

              <Stack gap="xs">
                {HERO_CONTENT.features.map((feature, index) => (
                  <Group key={index} gap="xs">
                    <Box
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        backgroundColor: `${BRAND_COLOR}15`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Box
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: BRAND_COLOR,
                        }}
                      />
                    </Box>
                    <Text size="sm" fw={500} c="#4B5563">
                      {feature}
                    </Text>
                  </Group>
                ))}
              </Stack>

              <Box
                mt="sm"
                style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'flex-start',
                  maxWidth: 600,
                  backgroundColor: `${BRAND_COLOR}08`,
                  border: `1px solid ${BRAND_COLOR}12`,
                  padding: '10px 12px',
                  borderRadius: 12,
                }}
              >
                <IconShieldCheck size={16} color="#6B7280" style={{ marginTop: 2, flexShrink: 0 }} />
                <Text size="xs" c="#4B5563" style={{ lineHeight: 1.6 }}>
                  {HERO_CONTENT.compliance}
                </Text>
              </Box>
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Box
              style={{
                width: '100%',
                borderRadius: 18,
                padding: 24,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(243,247,255,0.98) 100%)',
                border: `1px solid ${BRAND_COLOR}12`,
                boxShadow: '0 25px 70px rgba(25, 90, 214, 0.08)',
                backdropFilter: 'blur(6px)',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <Box
                style={{
                  position: 'absolute',
                  top: -40,
                  right: -60,
                  width: 200,
                  height: 200,
                  borderRadius: '50%',
                  background: `${BRAND_COLOR}08`,
                  filter: 'blur(40px)',
                }}
              />

              <Stack gap="xl">
                <Box style={{ textAlign: 'center' }}>
                  <Text fw={700} size="xl" c="#1F2329" mb="xs">
                    信息查询流程
                  </Text>
                  <Text size="sm" c="#6B7280">
                    简单四步，完成信息查询与展示
                  </Text>
                </Box>

                <Box
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: 16,
                  }}
                >
                  {highlights.map((item, index) => (
                    <Box
                      key={item.label}
                      style={{
                        padding: '20px 16px',
                        borderRadius: 14,
                        border: '1px solid #E5E7EB',
                        backgroundColor: '#FFFFFF',
                        textAlign: 'center',
                        position: 'relative',
                      }}
                    >
                      <Box
                        style={{
                          position: 'absolute',
                          top: 8,
                          left: 8,
                          width: 20,
                          height: 20,
                          borderRadius: '50%',
                          backgroundColor: `${BRAND_COLOR}15`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: 10,
                          fontWeight: 700,
                          color: BRAND_COLOR,
                        }}
                      >
                        {index + 1}
                      </Box>
                      <Box
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: '12px',
                          backgroundColor: `${BRAND_COLOR}12`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 12px',
                        }}
                      >
                        <item.icon size={24} color={BRAND_COLOR} />
                      </Box>
                      <Text size="sm" fw={600} c="#1F2329" mb={4}>
                        {item.label}
                      </Text>
                      <Text size="xs" c="#6B7280">
                        {item.desc}
                      </Text>
                    </Box>
                  ))}
                </Box>

                <Box
                  p="md"
                  style={{
                    borderRadius: 12,
                    backgroundColor: '#F8FAFC',
                    border: '1px solid #E5E7EB',
                  }}
                >
                  <Text size="sm" c="#4B5563" style={{ textAlign: 'center', lineHeight: 1.6 }}>
                    平台仅对信息进行查询、整理与展示
                    <br />
                    不提供任何判断、评估或建议
                  </Text>
                </Box>
              </Stack>
            </Box>
          </Grid.Col>
        </Grid>
      </Container>
    </Box>
  )
}
